// extracted by mini-css-extract-plugin
export default {"notification__dot":"NotificationItem_notification__dot__PQWUT"};